import { Decimal } from 'decimal.js';
import { utils } from 'ethers';
import { TpSlPositionParams } from '../../components/modals/EditPosition/EditPosition';
import { tokenDecimals } from '../config/contracts.config';

function calculateOnlyTakeProfitShort(openPrice: string | number,
                                      amount: string | number | Decimal,
                                      closePrice?: string | number,
                                      closeGainPercent?: string | number,
                                      closeAmount?: string | number) {

    const openPriceDecimal = new Decimal(openPrice);
    const amountDecimal = new Decimal(amount);
    let closePriceDecimal = closePrice ? new Decimal(closePrice) : undefined;
    let closeGainDecimal = closeGainPercent ? new Decimal(closeGainPercent).div(100) : undefined;
    let closeAmountDecimal = closeAmount ? new Decimal(closeAmount) : undefined;

    if (closePriceDecimal) {
        closeGainDecimal = openPriceDecimal.div(closePriceDecimal).minus(1);
        closeAmountDecimal = amountDecimal.mul(closeGainDecimal.add(1));
    } else if (closeGainDecimal) {
       closePriceDecimal =openPriceDecimal.div(closeGainDecimal.add(1));
       closeAmountDecimal = amountDecimal.mul(closeGainDecimal.add(1));

    } else if (closeAmountDecimal) {
        closeGainDecimal = closeAmountDecimal.div(amountDecimal).minus(1);
        closePriceDecimal = openPriceDecimal.div(closeGainDecimal.add(1));
    }
    return {
        closePriceDecimal,
        closeGainDecimal,
        closeAmountDecimal,
    };
}

function calculateOnlyTakeProfit(openPrice: string | number,
                                 amount: string | number | Decimal,
                                 closePrice?: string | number,
                                 closeGainPercent?: string | number,
                                 closeAmount?: string | number) {
    let closeGainDecimal = closeGainPercent ? new Decimal(closeGainPercent).div(100) : undefined;
    let closePriceDecimal = closePrice ? new Decimal(closePrice) : undefined;
    let closeAmountDecimal = closeAmount ? new Decimal(closeAmount) : undefined;
    if (closePriceDecimal) {
        closeGainDecimal = closePriceDecimal.sub(openPrice).div(openPrice); // +
        closeAmountDecimal = new Decimal(amount).mul(closeGainDecimal.add(1))
    } else if (closeGainDecimal) {
        closePriceDecimal = new Decimal(openPrice).mul(closeGainDecimal.add(1));
        closeAmountDecimal = new Decimal(amount).mul(closeGainDecimal.add(1));
    } else if (closeAmountDecimal) {
        closePriceDecimal = closeAmountDecimal.mul(openPrice).div(amount);
        closeGainDecimal = closeAmountDecimal.div(amount).sub(1);
    }

    return {
        closePriceDecimal,
        closeGainDecimal,
        closeAmountDecimal
    };
}

export function calculateTakeProfitParamsDecimal(
    openPrice: string | number,
    amount: string | number | Decimal,
    isTakeProfit: boolean,
    isLong: boolean,
    closePrice?: string | number,
    closeGainPercent?: string | number,
    closeAmount?: string | number
) {
    const fnResult = isLong ? calculateOnlyTakeProfit(openPrice, amount, closePrice, closeGainPercent, closeAmount) : calculateOnlyTakeProfitShort(openPrice, amount, closePrice, closeGainPercent, closeAmount)
    let preResult;

    if (isTakeProfit) {
        preResult = fnResult;
    } else { // isStopLoss
        preResult = {
            ...fnResult,
            closeGainDecimal: fnResult.closeGainDecimal?.mul(-1)
        }
    }

    return {
        closePrice: preResult?.closePriceDecimal,
        closeGainPercent: preResult?.closeGainDecimal && preResult?.closeGainDecimal.mul(100),
        closeAmount: preResult?.closeAmountDecimal
    }
}

export function calculateTakeProfitParamsDecimalAndFormatNumbers(
    openPrice: string | number,
    amount: string | number,
    isTakeProfit: boolean,
    isLong: boolean,
    closePrice?: string | number,
    closeGainPercent?: string | number,
    closeAmount?: string | number
): any {
    const result = calculateTakeProfitParamsDecimal(openPrice, amount, isTakeProfit, isLong, closePrice, closeGainPercent, closeAmount);
    return {
        closePrice: Number(result.closePrice?.toFixed(4)),
        closeGainPercent: Number(result.closeGainPercent?.toFixed(2)),
        closeAmount: Number(result.closeAmount?.toFixed(6))
    }
}

export function calculateTakeProfitParamsWithPosition(
    position: TpSlPositionParams,
    isTakeProfit: boolean,
    closePrice?: string | number,
    closeGainPercent?: string | number,
    closeAmount?: string | number
): any {
    const amountDecimal = utils.formatUnits(position.amount, tokenDecimals.usdc);
    const amountWithLeverage = new Decimal(amountDecimal).mul(position.leverage);
    const isLong = position.symbol.split(':')[2] === 'long';
    const result = calculateTakeProfitParamsDecimal(position.initialPrice, amountWithLeverage, isTakeProfit, isLong, closePrice, closeGainPercent, closeAmount);
    return {
        closePrice: Number(result.closePrice?.toFixed(8)),
        closeGainPercent: Number(result.closeGainPercent?.toFixed(2)),
        closeAmount: Number(result.closeAmount?.toFixed(8))
    }
}